export default __webpack_public_path__ + "static/How-you-can-land-the-best-hotel-deals-be1800b3f71cbd237a05cdc9f3dd6ebc.jpg";